(() => {
  if (window.__fareverAigcDisclaimerReady) return;
  window.__fareverAigcDisclaimerReady = true;

  const aigcImageFilenames = [
    'v0.1_20260816145822_324_29.png',
    'farever-homepage-hero-mobile-v1-portrait.png',
    'farever-melting-clock-gold-hero-v1-4k.png',
    'farever-melting-clock-silver-hero-v1-4k.png',
    'farever-melting-clock-vintage-black-gold-matte-hero-v1-4k.png',
  ];

  const disclaimerText =
    'AI-generated visualization for reference only. Actual product appearance may vary.';

  const isAigcImage = (image) => {
    const sources = [
      image.currentSrc,
      image.src,
      image.getAttribute('src'),
      image.getAttribute('srcset'),
    ].filter(Boolean);

    return sources.some((source) =>
      aigcImageFilenames.some((filename) => source.includes(filename))
    );
  };

  const findDisclaimerHost = (image) => {
    const knownHost = image.closest(
      '.banner__media, .farever-mobile-hero__media, .product__media'
    );
    if (knownHost) return knownHost;

    const cardMedia = image.closest('.card__media');
    if (cardMedia) return image.closest('.media') || cardMedia;

    const modal = image.closest('.product-media-modal__content');
    if (modal) {
      const mediaContainer = image.closest('.product-media-container');
      if (mediaContainer) return mediaContainer;
      return image.parentElement?.tagName === 'PICTURE'
        ? image.parentElement.parentElement
        : image.parentElement;
    }

    return null;
  };

  const updateCardHoverState = (cardMedia) => {
    if (!cardMedia) return;

    const hoverMedia =
      cardMedia.querySelector('.media--hover-effect') ||
      cardMedia.querySelector('.media');
    if (!hoverMedia) return;

    const images = Array.from(hoverMedia.querySelectorAll('img'));
    const primaryIsAigc = images.length > 0 && isAigcImage(images[0]);
    const hasRealSecondary = images.slice(1).some((image) => !isAigcImage(image));

    hoverMedia.classList.toggle(
      'farever-aigc-disclaimer-hide-on-hover',
      primaryIsAigc && hasRealSecondary
    );
  };

  const refreshCards = (root) => {
    const cards = new Set();

    if (root instanceof Element) {
      const nearestCard = root.closest('.card__media');
      if (nearestCard) cards.add(nearestCard);
    }

    root.querySelectorAll?.('.card__media').forEach((card) => cards.add(card));
    cards.forEach(updateCardHoverState);
  };

  const addDisclaimer = (image) => {
    if (!isAigcImage(image)) return;

    const host = findDisclaimerHost(image);
    if (!host || host.dataset.fareverAigcDisclaimer === 'true') return;

    host.dataset.fareverAigcDisclaimer = 'true';
    if (window.getComputedStyle(host).position === 'static') {
      host.classList.add('farever-aigc-disclaimer-host');
    }

    const disclaimer = document.createElement('span');
    disclaimer.className = 'farever-aigc-disclaimer';
    disclaimer.setAttribute('role', 'note');
    disclaimer.textContent = disclaimerText;
    host.appendChild(disclaimer);
  };

  const scan = (root = document) => {
    if (root instanceof HTMLImageElement) addDisclaimer(root);
    root.querySelectorAll?.('img').forEach(addDisclaimer);
    refreshCards(root);
  };

  const start = () => {
    scan();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          addDisclaimer(mutation.target);
          refreshCards(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) scan(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset'],
    });

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

